import colors from '../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        appBar: {
            alignItems: 'center',
            background: colors[mode].primaryBackground,
            borderBottom: `0.5px solid ${colors[mode].headerBorder}`,
            display: 'flex',
            flexDirection: 'row',
            height: '48px',
            justifyContent: 'space-between',
            overflowY: 'hidden',
            width: '100%',
            zIndex: 999
        },
        divider1: {
            borderLeft: `1px solid ${colors[mode].headerBorder}`,
            height: '100%'
        },
        divider2: {
            borderRight: `1px solid ${colors[mode].headerBorder}`,
            height: '100%',
            marginRight: '40px'
        },
        logoContainer: {
            '&:hover': {
                cursor: 'pointer'
            },
            alignItems: 'center',
            borderRight: `1px solid ${colors[mode].headerBorder}`,
            display: 'flex',
            height: '48px',
            justifyContent: 'center',
            paddingRight: '24px',
            width: '70px'
        },
        logoEn: {
            height: '30px',
            width: '67px'
        },
        logoFr: {
            height: '30px',
            width: '84px'
        },
        menuItemsGroup1: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            marginLeft: 'auto'
        },
        root: {
            backgroundColor: colors[mode].factorBackground,
            display: 'flex',
            paddingBottom: '73px'
        },
        themeIcon: {
            color: colors[mode].primaryText,
            height: '19px',
            marginTop: '3px',
            width: '19px'
        },
        themeIconBox: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            marginBottom: '2px',
            marginRight: '30px'
        },
        title: {
            [theme.breakpoints.down('xs')]: {
                visibility: 'hidden',
                width: '0px'
            },
            color: colors[mode].titleColor,
            fontFamily: 'RBCDisplay Regular',
            fontSize: '17px',
            fontWeight: 400,
            lineHeight: '25px'
        },
        titleBox:{
            '@media (min-width: 0px) and (max-width: 450px)': {
                display: 'none'
            },
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            height: '48px',
            justifyContent: 'center',
            textAlign: 'center',
            width: '189.6px'
        },

        toolbar: {
            [theme.breakpoints.down('sm')]: {
                paddingRight: '0px'
            },
            alignItems: 'center',
            display: 'flex',
            height: 'inherit',
            justifyContent: 'space-between',
            paddingRight: '64px',
            width: '100%'
        },
        toolbarMobile: {
            paddingRight: '0px'
        },
        toolbarProfile: {
            marginLeft: '117.5px'
        },
    }
}

export default styles